export const C = {
  deepsea:  '#223469',
  liquid:   '#25A8E0',
  liquidDk: '#1F94C8',
  sky:      '#94D3EF',
  abyss:    '#1A2856',
  tide:     '#2D4080',
  foam:     '#C7CEDF',
  iron:     '#696969',
  silver:   '#BAB9B9',
  mercury:  '#E6E6E6',
  platinum: '#F5F5F5',
  chrome:   '#F7F7F7',
  tin:      '#FFFFFF',
  patina:   '#5CAF01',
  rust:     '#D10720',
  brass:    '#EF9500',
  copper:   '#FF8A8A',
  rowHover: '#F0F8FD',
  rowActive:'#E1F2FA',
  fg:       '#1F1F1F',
  fg2:      '#696969',
  fg3:      '#BAB9B9',
  // Billing accents (request cards): bug = amber, quote = blue, sponsored = purple
  billBug:  '#EF9500',
  billQuote:'#25A8E0',
  billSponsor:'#8E5BC6',
};
